export default __webpack_public_path__ + "static/media/icon-copy.d801a8dc.svg";